class ProductInfoScroll {
  constructor() {
    this.productInfoWrapper = null;
    this.isMobile = false;

    this.init();
  }

  init() {
    if (window.innerWidth >= 750) return;
    this.isMobile = true;

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => this.setup());
    } else {
      this.setup();
    }

    window.addEventListener('resize', this.handleResize.bind(this));
  }

  setup() {
    this.productInfoWrapper = document.querySelector('.product .product__info-wrapper');

    if (!this.productInfoWrapper) return;

    this.setDynamicHeights();
  }

  setDynamicHeights() {
    const productInfo = this.productInfoWrapper.querySelector('.product__info-container');
    if (!productInfo) return;

    const buyButtons = productInfo.querySelector('.product-form__submit');
    if (!buyButtons) return;

    const buyButtonsRect = buyButtons.getBoundingClientRect();
    const productInfoRect = productInfo.getBoundingClientRect();
    const visibleHeight = buyButtonsRect.bottom - productInfoRect.top;

    const totalHeight = productInfo.scrollHeight;

    const remainingContent = totalHeight - visibleHeight;
    const marginBottom = remainingContent + 20;

    this.productInfoWrapper.style.height = `${visibleHeight}px`;
    this.productInfoWrapper.style.marginBottom = `${marginBottom}px`;
  }

  handleResize() {
    const wasMobile = this.isMobile;
    this.isMobile = window.innerWidth < 750;

    if (wasMobile !== this.isMobile) {
      if (this.isMobile) {
        this.setup();
      } else if (!this.isMobile) {
        this.cleanup();
      }
    } else if (this.isMobile) {
      this.setDynamicHeights();
    }
  }

  cleanup() {
    if (this.productInfoWrapper) {
      this.productInfoWrapper.style.height = '';
      this.productInfoWrapper.style.marginBottom = '';
    }
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new ProductInfoScroll();
  });
} else {
  new ProductInfoScroll();
}
